import { connect } from "react-redux";
import MainFrame from "./MainFrame";
import { DRAWER_STATE, openDrawer } from "./actions/drawer";

const mapStateToProps = (state, ownProps) => {
  const drawerIsDocked = state.ui.geometry.drawer === DRAWER_STATE.DOCKED;
  return {
    indent: drawerIsDocked ? 250 : 0,
    isInMonitoringMode: state.ui.focused
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onOpenDrawer: () => {
      dispatch(openDrawer());
    }
  };
};

const MainFrameContainer = connect(mapStateToProps, mapDispatchToProps)(
  MainFrame
);

export default MainFrameContainer;



// WEBPACK FOOTER //
// ./src/MainFrameContainer.js